/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeApplyResponseWorkingMode } from './workingModeApplyResponseWorkingMode';
import type { WorkingModeApplyResponseJobId } from './workingModeApplyResponseJobId';
import type { WorkingModeDiff } from './workingModeDiff';

export interface WorkingModeApplyResponse {
  workingMode: WorkingModeApplyResponseWorkingMode;
  jobId?: WorkingModeApplyResponseJobId;
  diff: WorkingModeDiff;
}
